import { render, staticRenderFns } from "./SaleOfPoint.vue?vue&type=template&id=c841767e&scoped=true"
import script from "./SaleOfPoint.vue?vue&type=script&lang=js"
export * from "./SaleOfPoint.vue?vue&type=script&lang=js"
import style0 from "./SaleOfPoint.vue?vue&type=style&index=0&id=c841767e&prod&scoped=true&lang=css"
import style1 from "./SaleOfPoint.vue?vue&type=style&index=1&id=c841767e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c841767e",
  null
  
)

export default component.exports